import { useEffect, useState } from "react";
import { Phone, MessageCircle } from "lucide-react";
import { BUSINESS } from "@/data/business";
import { motion, AnimatePresence } from "framer-motion";

const FloatingActions = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.35 }}
          className="fixed bottom-6 right-6 sm:bottom-8 sm:right-8 z-50 flex flex-col gap-3"
          data-testid="floating-actions"
        >
          <a
            href={`https://wa.me/${BUSINESS.whatsappRaw}?text=${encodeURIComponent(
              "Hi New India Trading Corporation, I'd like to enquire about your plywood products.",
            )}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-button"
            className="group relative h-14 w-14 sm:h-14 sm:w-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-10px_rgba(37,211,102,0.6)] flex items-center justify-center hover:scale-105 transition-transform"
            aria-label="Chat on WhatsApp"
          >
            <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366]/40 animate-ping" />
            <MessageCircle className="h-6 w-6 relative" />
          </a>
          <a
            href={`tel:${BUSINESS.phoneRaw}`}
            data-testid="floating-call-button"
            className="h-14 w-14 rounded-full bg-[color:var(--nitc-accent)] hover:bg-[color:var(--nitc-accent-hover)] text-white shadow-[0_10px_30px_-10px_rgba(122,78,45,0.55)] flex items-center justify-center hover:scale-105 transition-transform"
            aria-label="Call us"
          >
            <Phone className="h-5 w-5" />
          </a>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingActions;
